import axios from "axios";
import API from "../api";


////
// THIS MODULE SHOULD BE MERGED WITH BOOKING MODULE AND UTILIZE SOME OF THEIR EXISTING CALLS.
// THIS GENERATES A 500 ERROR WHEN THERE IS NO TAB WITH A CONTACT
////

export const GuestPastBookingsModule = {
  state: {
    isRequesting: false,
    errored: false,
    error: ""
  },

  actions: {
    getGuestPastBookings({
      commit
    }, guestId) {
      return new Promise(async (resolve, reject) => {
        commit("getGuestPastBookingsRequest");
        return axios
          .get(`${API.BASE_URL}${API.TABS}?guest_id=${guestId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getGuestPastBookingsSuccess", response.data);
              resolve(response.data);
            } else {
              console.log(response.data);
              console.log(response.status);
              console.log(response.headers);
              reject(response);
            }
          })
          .catch(error => {
            commit("guestPastBookingsError", error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    getGuestPastBookingsRequest(state) {
      state.isRequesting = true;
    },
    getGuestPastBookingsSuccess(state) {
      state.isRequesting = false;
    },
    guestPastBookingsError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    }
  }
};